import React from 'react';
import propTypes from 'prop-types';
export const TourIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      fill={color}
      height={sizeInPixel}
      width={sizeInPixel}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 511.974 511.974"
      xmlSpace="preserve"
    >
      <g>
        <g>
          <g>
            <polygon points="216.04,186.085 207.985,218.247 240.172,210.208 286.773,163.608 262.641,139.476 			" />
            <path
              d="M295.547,112.041c-1.51-1.502-3.959-1.502-5.478,0l-15.36,15.369l24.132,24.132l15.369-15.369
               c0.99-0.99,1.135-2.133,1.135-2.731c0-0.597-0.145-1.749-1.135-2.739L295.547,112.041z"
            />
            <path
              d="M255.987,0C161.882,0,85.321,76.553,85.321,170.641c0,45.901,14.003,73.924,33.391,112.708
               c3.012,6.025,6.17,12.331,9.438,19.038c47.753,98.065,120.055,204.792,120.781,205.858c1.587,2.33,4.233,3.729,7.057,3.729
               c2.825,0,5.47-1.399,7.057-3.729c0.725-1.067,73.028-107.793,120.789-205.858c3.26-6.707,6.417-13.013,9.429-19.038
               c19.388-38.784,33.391-66.807,33.391-112.708C426.654,76.553,350.093,0,255.987,0z M326.276,148.241l-75.708,75.708
               c-1.092,1.092-2.458,1.869-3.959,2.244l-48.29,12.058c-0.683,0.171-1.374,0.256-2.065,0.256c-2.236,0-4.412-0.879-6.033-2.5
               c-2.116-2.125-2.97-5.197-2.244-8.107l12.075-48.256c0.375-1.502,1.152-2.867,2.253-3.959l54.298-54.306l0.009-0.009
               l21.393-21.393c8.166-8.166,21.453-8.166,29.611,0l18.662,18.654c3.959,3.959,6.135,9.216,6.135,14.814
               C332.412,139.034,330.227,144.29,326.276,148.241z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};
TourIcon.prototype = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
TourIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
